import React from 'react';
import { IconSitemap } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const CostCenters = () => (
    <SimpleLookupCrud
        icon={IconSitemap}
        gradient="blue"
        title="Centros de Custo"
        subtitle="Classificação de despesas/receitas por área da empresa"
        endpoint="cost-centers"
        addLabel="Novo centro de custo"
        columns={[
            { key: 'code', label: 'Código', type: 'text' },
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'parent', label: 'Centro de custo pai', type: 'select', optionsSource: 'self' },
            { key: 'is_active', label: 'Ativo', type: 'checkbox', default: true }
        ]}
    />
);

export default CostCenters;
